/**
 * English translations module auto-merge
 * This file automatically imports all modules and merges them into a single object
 */
import common from './common'
import nav from './nav'
import home from './home'
import profile from './profile'
import account from './account'
import login from './login'
import error from './error'
import userDetail from './userDetail'
import product from './product'
import payment from './payment'
import chat from './chat'
import videoCall from './videoCall'
import messages from './messages'

export default {
  common,
  nav,
  home,
  profile,
  account,
  login,
  error,
  userDetail,
  product,
  payment,
  chat,
  videoCall,
  messages,
}
